export const removeAtIndexOnDeleteKey = (e, index) => {
  return e.substring(0, index) + e.substring(index + 1);
};
